<template>
  <v-layout
    class="color-picker"
    justify-center
    column
  >
    <v-flex
      :class="['label','p-0', {'custom-error-color': validator && validator.$error}]"
    >
      <span>{{ label }}</span>
    </v-flex>

    <v-flex shrink class="p-0">
      <v-menu
        offset-y
        open
        :close-on-content-click="false"
      >
        <v-btn
          slot="activator"
          :color="color.hex ? color.hex: 'primary'"
          class="size-32 m-0 field-icon"
          icon
        >
          <v-icon color="white">color_lens</v-icon>
        </v-btn>
        <sketch :value="color" @input="onColorChange" />
      </v-menu>
    </v-flex>
    <v-flex
      style="padding:0px"
      :class="['custom-error-message', {'error--text': validator && validator.$error}]"
    >
      <span> {{ getErrors(validator)[0] }} &nbsp;</span>
    </v-flex>
  </v-layout>
</template>

<script>
import AdminContext from '@/admin-i18n/context'

import { Sketch } from 'vue-color'
import { defaultMessages, getValidationErrors } from './../../../utils'

export default {
  mixins: [AdminContext],
  name: 'color-picker-field',
  components: {
    Sketch,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
    onChange: Function,
    errorMessages: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      color: { hex: this.value || '#000'},
    }
  },
  watch: {
    value(val){
      this.color = { hex: val}
    },
    color: {
      handler(val){
        this.validator && this.validator.$touch()
        this.$emit('input', val.hex)
      },
      deep: true,
    },
  },
  methods: {
    onColorChange(color) {
      if (this.onChange) return this.onChange(color)

      this.color = color
    },
    getErrors: function(field){
      return getValidationErrors({
        ...this.adminValidationMessages(defaultMessages),
        ...this.adminFieldValidationMessages(this.errorMessages),
      })(field)
    },

  },
}
</script>

<style scoped>
.color-picker{
  padding: 0px 16px;
}

.field-icon{
  margin-top: 8px !important;
}

.size-32 {
  width: 32px;
  height: 32px;
}

.label {
  line-height:16px;
  font-size: 16px;
  color: #979797;
}


</style>
